export const DIAGNOSTIC_REPORT = '/u/diagnostic-reports/$diagnosticReportId';
export const DIAGNOSTIC_REPORT_REQUEST = '/u/patient/diagnostic-report-request';
export const DIAGNOSTIC_REPORT_SENT = '/u/patient/diagnostic-report-sent';
export const IMAGE_PROTOCOL_REQUEST = '/u/patient/image-protocol-request';
export const IMAGE_PROTOCOLS = '/u/patient/image-protocols';
export const PSORIASIS_INFO = '/u/patient/psoriasis-info';
export const PATIENT_ENCOUNTER_LIST = '/u/encounters';
export const DIAGNOSTIC_REPORTS = '/u/diagnostic-reports';
export const DOCUMENT_LIST = '/u/documents';
export const DOCUMENT_CREATE = '/u/documents/create';
export const SUPPORT = '/u/support';

const paths = {
  DIAGNOSTIC_REPORT,
  DIAGNOSTIC_REPORT_REQUEST,
  DIAGNOSTIC_REPORT_SENT,
  IMAGE_PROTOCOL_REQUEST,
  IMAGE_PROTOCOLS,
  DIAGNOSTIC_REPORTS,
  PATIENT_ENCOUNTER_LIST,
  PSORIASIS_INFO,
  DOCUMENT_LIST,
  DOCUMENT_CREATE,
  SUPPORT
};

export default paths;
